/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'

const IconEmail = props => {
  const { className, width = 24, height = 24, onClick, style } = props
  const title = 'icon-email'
  const dataTestId = props['data-testid'] || title

  return (
    <svg
      className={className}
      style={style}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      onClick={onClick}
      data-testid={dataTestId}
    >
      <g data-rebalance="1.086" transform="translate(12 12) scale(1.086) translate(-12 -12)">
        <title>{title}</title>
        <path d="M19.992 4.008h-15.984c-1.104 0-1.992 0.888-1.992 1.992l-0.024 12c0 1.104 0.912 1.992 2.016 1.992h15.984c1.104 0 2.016-0.888 2.016-1.992v-12c0-1.104-0.912-1.992-2.016-1.992zM19.992 7.992l-7.992 5.016-7.992-5.016v-1.992l7.992 4.992 7.992-4.992v1.992z" />
      </g>
    </svg>
  )
}

export default IconEmail
